<template>
  <div>
    <div v-if="showSarasas">
      <div v-for="item in filteredIgaliojimaiSarasas" :key="item.id">
        <el-checkbox
          class="white-space:pre"
          :check-value="item.id"
          :label="item.igaliojimas"
          v-model="sarasasItem"
          :disabled="item.disabled"
          :readonly="item.readonly"
          @click.native="clickIgaliojimas()"
        >
        </el-checkbox>
      </div>
    </div>
    <div v-if="showNera">
      <v-row>
        <v-col class="my-3">
          {{ $t('Įgaliojimų Registre galiojančių įgaliojimų nerasta.') }}
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IgaliojimasSarasas',
  components: {},
  props: {
    pazyma: Object,
    asmuo: Object,
    readonly: Boolean,
  },
  data() {
    return {
      igaliojimaiTab: null,
      loading: true,
      search: null,
      searchData: {},
      igaliojimaiSarasas: [],
      sarasasItem: null,

      itemsPerPageOptions: [10, 50, 100, -1],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    isReadonly() {
      return this.readonly
    },
    filteredIgaliojimaiSarasas() {
      if (this.pazyma.paz_readonly) {
        return this.igaliojimaiSarasas
          .filter(igaliojimas => {
            return igaliojimas.id == this.pazyma.paz_igaliojimai.id
          })
          .map(igaliojimas => {
            igaliojimas.value = igaliojimas.id

            igaliojimas.disabled =
              this.sarasasItem && this.sarasasItem !== igaliojimas.id

            igaliojimas.readonly = this.pazyma.paz_readonly

            return igaliojimas
          })
      }

      return this.igaliojimaiSarasas.map(igaliojimas => {
        igaliojimas.value = igaliojimas.id

        igaliojimas.disabled =
          this.sarasasItem && this.sarasasItem !== igaliojimas.id

        return igaliojimas
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    pazymaId() {
      return this.pazyma?.paz_id
    },
    showSarasas() {
      return this.filteredIgaliojimaiSarasas.length > 0
    },
    showNera() {
      return !this.loading && this.filteredIgaliojimaiSarasas.length === 0
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true

      this.$axios
        .get(`ntrpaslaugos/pazyma/${this.pazyma?.paz_id}/igaliojimai/sarasas`)
        .then(res => {
          this.igaliojimaiSarasas = res.data.igaliojimai_sarasas
          this.sarasasItem = this.pazyma.paz_igaliojimai?.id ?? null
          this.$emit('loaded')
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },

    clickIgaliojimas() {
      if (this.isReadonly) {
        return
      }
      this.loading = true
      this.$emit('isLoading')

      if (!this.sarasasItem) {
        this.deleteData()
        return
      }

      const igaliojimas = this.filteredIgaliojimaiSarasas.filter(
        igaliojimas => {
          return igaliojimas.id === this.sarasasItem
        }
      )
      this.saveData(igaliojimas?.[0])
    },

    saveData(igaliojimas) {
      const data = {
        ...igaliojimas,
      }
      this.$axios
        .post(`ntrpaslaugos/pazyma/${this.pazymaId}/igaliojimai`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.$emit('updatePazyma')
        })
    },

    deleteData() {
      this.$axios
        .delete(`ntrpaslaugos/pazyma/${this.pazymaId}/igaliojimai`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.$emit('updatePazyma')
        })
    },
  },
}
</script>
